import React from 'react';
import '../../assets/css/style.css';

export default function Adjuster() {
    return (
        <div className ="color-adjuster">
            <br></br>
             <br></br>
            <br></br>
        </div>
    )
}
